import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import BaseLayout from './BaseLayout';
import SosdbRoleActionTable from '../SosdbRoleActionTable';
import Storage from '../../Storage';
import { browserHistory } from 'react-router';
import XpressTemplateTable from '../XpressTemplateTable';
import MigratePage from './MigratePage';
import SosdbG2ConvertHistoryTable from '../SosdbG2ConvertHistoryTable';
import PatchPage from './PatchPage';
import G2CopyPage from './G2CopyPage';
import SosdbG2CopyHistory from '../SosdbG2CopyHistory';
import Org2OrgCopyPage from './Org2OrgCopyPage';
import Org2OrgCopyPageHistory from './Org2OrgCopyPageHistory';

class AdminPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedIndex: this.calcTabIndexFromUrlPath(),
    };
    this.onBrowserHistoryChange = this.onBrowserHistoryChange.bind(this);
  }

  onBrowserHistoryChange() {
    let { location } = this.props;
    // when browser back button is pressed
    if (location.action === 'POP' && !this.unmounted) {
      this.handleSelect(this.calcTabIndexFromUrlPath());
    }
  }

  componentDidMount() {
    this.handleSelect(this.calcTabIndexFromUrlPath());
    this.unsubscribeBrowserHistoryChange = browserHistory.listen(this.onBrowserHistoryChange);
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.unsubscribeBrowserHistoryChange) {
      this.unsubscribeBrowserHistoryChange();
    }
  }

  calcTabIndexFromUrlPath() {
    let pathname = this.props.location.pathname;
    let index = 0;
    switch (pathname) {
      case '/admin/xpresstemplates':
        index = 0;
        break;
      case '/admin/migratekiosk':
        index = 1;
        break;
      case '/admin/migrationhistory':
        index = 2;
        break;
      case '/admin/patch':
        index = 3;
        break;
      case '/admin/g2copy':
        index = 4;
        break;
      case '/admin/g2copyhistory':
        index = 5;
        break;
      case '/admin/org2orgcopy':
        index = 6;
        break;
      case '/admin/org2orgcopyhistory':
        index = 7;
        break;
    }
    // console.log('calc', pathname, index);
    return index;
  }

  handleSelect(index, last) {
    // console.log('handleSelect', index, last);
    this.setState({ selectedIndex: index }, () => {
      switch (index) {
        case 0:
          Storage.setTabPathname('admin', '/admin/xpresstemplates');
          break;
        case 1:
          Storage.setTabPathname('admin', '/admin/migratekiosk');
          break;
        case 2:
          Storage.setTabPathname('admin', '/admin/migrationhistory');
          break;
        case 3:
          Storage.setTabPathname('admin', '/admin/patch');
          break;
        case 4:
          Storage.setTabPathname('admin', '/admin/g2copy');
          break;
        case 5:
          Storage.setTabPathname('admin', '/admin/g2copyhistory');
          break;
        case 6:
          Storage.setTabPathname('admin', '/admin/org2orgcopy');
          break;
        case 7:
          Storage.setTabPathname('admin', '/admin/org2orgcopyhistory');
          break;
      }
      browserHistory.push(Storage.getTabPathname('admin', '/admin/xpresstemplates'));
    });
  }

  render() {
    return (
      <BaseLayout {...this.props} selectedTabName='admin'>
        <Tabs
          onSelect={this.handleSelect.bind(this)}
          selectedIndex={this.state.selectedIndex}
        >
          <TabList style={{textAlign: 'center'}}>
            <Tab><i className='fa fa-fw fa-files-o'/>Xpress Templates</Tab>
            <Tab><i className='fa fa-fw fa-arrows'/>Migrate G2 to V5</Tab>
            <Tab><i className='fa fa-fw fa-clock-o'/>Migration History</Tab>
            <Tab><i className='fa fa-fw fa-clock-o'/>Patch Management</Tab>
            <Tab><i className='fa fa-fw fa-clock-o'/>G2 Copy</Tab>
            <Tab><i className='fa fa-fw fa-clock-o'/>G2 Copy History</Tab>
            <Tab><i className='fa fa-fw fa-clone'/>Org to Org Copy</Tab>
            <Tab><i className='fa fa-fw fa-clone'/>Org to Org Copy History</Tab>
          </TabList>
          <TabPanel>
            <XpressTemplateTable {...this.props} tableTitle='Xpress Templates' />
          </TabPanel>
          <TabPanel>
            <MigratePage {...this.props} handleSelect={this.handleSelect.bind(this)} />
          </TabPanel>
          <TabPanel>
            <SosdbG2ConvertHistoryTable {...this.props} tableTitle='Migration History' />
          </TabPanel>
          <TabPanel>
            <PatchPage {...this.props} tableTitle='Migration History' />
          </TabPanel>
          <TabPanel>
            <G2CopyPage
              {...this.props}
              handleSelect={this.handleSelect.bind(this)}
              tableTitle='G2 Copy'
            />
          </TabPanel>
          <TabPanel>
            <SosdbG2CopyHistory {...this.props} tableTitle='G2 Copy History' />
          </TabPanel>
          <TabPanel>
            <Org2OrgCopyPage
              {...this.props}
              handleSelect={this.handleSelect.bind(this)}
              tableTitle='Org to Org Copy'
            />
          </TabPanel>
          <TabPanel>
            <Org2OrgCopyPageHistory {...this.props} tableTitle='Org to Org Copy History' />
          </TabPanel>
        </Tabs>
      </BaseLayout>
    );
  }
}

export default AdminPage;



// WEBPACK FOOTER //
// ./src/components/pages/AdminPage.js